import { h } from '@stencil/core';

const CheckboxField = ({ groupProps, checkboxProps, name, labelRef = null, label, termsStyle = false, labelHtml = null, validate = {} }) => {
  const { ref, unRef, ...restCheckboxProps } = checkboxProps(name);

  return (
    <div {...groupProps(name)}>
      <rentware-checkbox
        {...restCheckboxProps}
        {...validate}
        inputRef={ref}
        labelRef={labelRef}
        termsStyle={termsStyle}
        inputUnRef={unRef}
        label={label}
        labelHtml={labelHtml}
        error={restCheckboxProps.error}
      />
    </div>
  );
};

export default CheckboxField;
